<template>
  <v-container
    id="clientes-rfv-faturado-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="background-color: #fff; margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <dashboard-filtro-datas
              :primeiro="enablePrimeiroDia"
              :ultimo="enableUltimoDia"
              :empresas="enableEmpresa"
              :vendedores="enableVendedor"
              :supervisores="enableSupervisor"
              :receitas="enableReceita"
              :segmentos="enableSegmento"
              :url="link"
              :redes="enableRede"
              :categorias="enableCategoria"
              :promotores="enablePromotor"
            />
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="2"
              >
                <v-row>
                  <v-col
                    id="componenteClientes"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'241'"
                      :text="'Campeões'"
                      :texto-information="textoCampeoes"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="clientesCampeoes"
                      :padding="'padding-right: 11rem !important'"
                      :loading="loadingClientesCampeoes"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    id="componenteClientesLeais"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'242'"
                      :text="'Leais'"
                      :texto-information="textoCampeoes"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="clientesLeais"
                      :padding="'padding-right: 11rem !important'"
                      :loading="loadingLeais"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    id="componenteClientesLeais"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'243'"
                      :text="'Hibernando'"
                      :texto-information="textoHibernando"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="clientesHibernando"
                      :padding="'padding-right: 11rem !important'"
                      :loading="loadingHibernando"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="8"
              >
                <v-row>
                  <v-col
                    id="componenteClientes"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <v-card
                      id="cardDashbord"
                      class="mx-auto"
                      outlined
                    >
                      <div class="card-header-dashbord">
                        <v-row>
                          <v-col
                            cols="12"
                            sm="10"
                            md="10"
                            lg="10"
                            class="d-flex flex-wrap"
                          >
                            Qual a minha distribuição da carteira RFV?
                          </v-col>
                          <v-col
                            cols="12"
                            sm="2"
                            md="2"
                            lg="2"
                            class="d-flex justify-end"
                          >
                            <v-tooltip
                              top
                              max-width="400"
                              width="400"
                            >
                              <template
                                v-slot:activator="{ on, attrs }"
                              >
                                <v-icon
                                  id="iconInformationFatxMetaComercial4"
                                  class="text-left"
                                  v-bind="attrs"
                                  v-on="on"
                                  @mouseover="enableTexto('244')"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <div
                                v-if="!carregandoTooltip"
                                v-html="textoOrientacao"
                              />
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </div>
                      <v-card-actions>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <dashboard-maps-cliente-rfc />
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    id="componenteClientesLeais"
                    cols="12"
                    sm="4"
                    md="4"
                    lg="4"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'245'"
                      :text="'Preocupantes'"
                      :texto-information="textoPreocupantes"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="clientesPreocupantes"
                      :padding="'padding-right: 14rem !important'"
                      :loading="loadingPreocupantes"
                    />
                  </v-col>
                  <v-col
                    id="componenteClientesLeais"
                    cols="12"
                    sm="4"
                    md="4"
                    lg="4"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'246'"
                      :text="'Em Risco'"
                      :texto-information="textoEmRisco"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="clientesRisco"
                      :padding="'padding-right: 14rem !important'"
                      :loading="loadingRisco"
                    />
                  </v-col>
                  <v-col
                    id="componenteClientesLeais"
                    cols="12"
                    sm="4"
                    md="4"
                    lg="4"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'247'"
                      :text="'Não Podemos Perder'"
                      :texto-information="textoNaoPerder"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="clientesNaoPerder"
                      :padding="'padding-right: 14rem !important'"
                      :loading="loadingNaoPerder"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="2"
              >
                <v-row>
                  <v-col
                    id="componenteClientes"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'248'"
                      :text="'Novos'"
                      :texto-information="textoNovos"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="clientesNovos"
                      :padding="'padding-right: 11rem !important'"
                      :loading="loadingNovos"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    id="componenteClientesLeais"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'249'"
                      :text="'Promissores'"
                      :texto-information="textoPromissores"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="clientesPromissores"
                      :padding="'padding-right: 11rem !important'"
                      :loading="loadingPromissores"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    id="componenteClientesLeais"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'250'"
                      :text="'Potencias'"
                      :texto-information="textoPonteciais"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="clientesPotencias"
                      :padding="'padding-right: 11rem !important'"
                      :loading="loadingPotencias"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                id="componenteClientesLeais"
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Matriz de Riscos de R.F.V.
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip
                          top
                          max-width="400"
                          width="400"
                        >
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              id="iconInformationFatxMetaComercial4"
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('251')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="!carregandoTooltip"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-card-actions>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <div
                          id="idTable"
                          style="overflow-x: auto;"
                        >
                          <table
                            style="width: 100%; color: black; border-collapse: collapse;"
                            class="elevation-1"
                            mobile-breakpoint="0"
                          >
                            <thead>
                              <tr>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="text-align: center;"
                                  class="black--text title"
                                >
                                  Valor de frequencia
                                </th>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="text-align: center;"
                                  class="black--text title"
                                >
                                  R1 - Inativo
                                </th>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="text-align: center;"
                                  class="black--text title"
                                >
                                  R2 - 181 a 270 dias
                                </th>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="text-align: center;"
                                  class="black--text title"
                                >
                                  R3 - 121 a 180 dias
                                </th>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="text-align: center;"
                                  class="black--text title"
                                >
                                  R4 - 61 a 120 dia
                                </th>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="text-align: center;"
                                  class="black--text title"
                                >
                                  R5 - até 60 dias
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="item in dadosMatriz"
                                :key="item.id"
                              >
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: left;"
                                >
                                  {{ item.frequencia }}
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: right;"
                                >
                                  <v-chip
                                    :color="getColorR1(item)"
                                    dark
                                  >
                                    {{ item.r1 }}
                                  </v-chip>
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: right;"
                                >
                                  <v-chip
                                    :color="getColorR2(item)"
                                    dark
                                  >
                                    {{ item.r2 }}
                                  </v-chip>
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: right;"
                                >
                                  <v-chip
                                    :color="getColorR3(item)"
                                    dark
                                  >
                                    {{ item.r3 }}
                                  </v-chip>
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: right;"
                                >
                                  <v-chip
                                    :color="getColorR4(item)"
                                    dark
                                  >
                                    {{ item.r4 }}
                                  </v-chip>
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: right;"
                                >
                                  <v-chip
                                    :color="getColorR5(item)"
                                    dark
                                  >
                                    {{ item.r5 }}
                                  </v-chip>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Cliente from '../../../../../services/somentecliente'
  import Permissao from '../../../../../services/menu'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardClienteRFC',
    emits: ['setDadosGeolocalizacao', 'setUpdateDadosRfv', 'enableFaturamento', 'disableLoading', 'atualizarTexto'],
    components: {
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
      DashoardCardView: () => import('../../../components/core/CardView'),
      DashboardMapsClienteRfc: () => import('../../../maps/SomenteClientes/DashboardMapsClientesRFC'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleClientesCampeoes: {
        color: '#4CAF50',
      },
      styleClientesLeais: {
        color: '#C8E6C9',
      },
      styleClientesHibernando: {
        color: '#FFC107',
      },
      styleClientesPreocupantes: {
        color: '#FFE082',
      },
      styleClientesRisco: {
        color: '#FF5722',
      },
      styleClientesNaoPerder: {
        color: '#F44336',
      },
      styleClientesNovos: {
        color: '#2196F3',
      },
      styleClientesPromissores: {
        color: '#64B5F6',
      },
      styleClientesPotenciais: {
        color: '#BBDEFB',
      },
      valorReceber: localStorage.valorReceber,
      valorVencido: 0,
      paginaEnable: false,
      permissaoContasReceber: '',
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      vendedores: [],
      area: [],
      rede: [],
      supervisor: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableVendedor: true,
      enableSupervisor: true,
      enableReceita: true,
      enableSegmento: true,
      enableRede: true,
      enableCategoria: true,
      enablePromotor: true,
      link: localStorage.linkClientes,
      clientesCampeoes: '0',
      dadosCampeoes: [],
      clientesLeais: '0',
      dadosLeais: [],
      clientesHibernando: '0',
      dadosHibernando: [],
      clientesPreocupantes: '0',
      dadosPreocupantes: [],
      clientesRisco: '0',
      dadosRisco: [],
      clientesNaoPerder: '0',
      dadosNaoPerder: [],
      clientesPotencias: '0',
      dadosPotencias: [],
      clientesPromissores: '0',
      dadosPromissores: [],
      clientesNovos: '0',
      dadosNovos: [],
      dadosMatriz: [],
      headersDevolucaoClientes: [
        { text: 'Valor de frequencia', value: 'frequencia', width: '300px', class: 'black--text title' },
        { text: 'R1 - Inativo', value: 'r1', width: '120px', align: 'right', class: 'black--text title' },
        { text: 'R2 - 181 a 270 dias', value: 'r2', width: '120px', align: 'right', class: 'black--text title' },
        { text: 'R3 - 121 a 180 dias', value: 'r3', width: '120px', align: 'right', class: 'black--text title' },
        { text: 'R4 - 61 a 120 dias', value: 'r4', width: '120px', align: 'right', class: 'black--text title' },
        { text: 'R5 - até 60 dias', value: 'r5', width: '120px', align: 'right', class: 'black--text title' },
      ],
      loading: false,
      error: null,
      errorCampeoes: null,
      errorLeais: null,
      errorHibernando: null,
      errorPreocupantes: null,
      errorNovos: null,
      codigo: 0,
      orientacao: [],
      textoCampeoes: '',
      textoLeias: '',
      textoHibernando: '',
      textoDistribuicaoRFV: '',
      textoPreocupantes: '',
      textoEmRisco: '',
      textoNaoPerder: '',
      textoNovos: '',
      textoPromissores: '',
      textoPonteciais: '',
      textoMatrizRFV: '',
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      loadingCampeoes: false,
      loadingLeais: false,
      loadingHibernando: false,
      loadingPreocupantes: false,
      loadingRisco: false,
      loadingNaoPerder: false,
      loadingNovos: false,
      loadingPromissores: false,
      loadingPotencias: false,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Relatório R.F.C Clientes')

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, area, rede, supervisor, receita, segmento, classificacao, produto, cidade, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedores = vendedores
        this.area = area
        this.rede = rede
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor

        this.updateDate()
      },

      updateDate () {
        this.clientesCampeoes = '0'
        this.clientesLeais = '0'
        this.clientesHibernando = '0'
        this.clientesPreocupantes = '0'
        this.clientesRisco = '0'
        this.clientesNaoPerder = '0'
        this.clientesPotencias = '0'
        this.clientesPromissores = '0'
        this.clientesNovos = '0'

        this.dadosCampeoes = []
        this.dadosPromissores = []
        this.dadosPotencias = []
        this.dadosLeais = []
        this.dadosHibernando = []
        this.dadosRisco = []
        this.dadosNovos = []
        this.dadosPreocupantes = []
        this.dadosNaoPerder = []

        this.dadosMatriz = []

        this.loadingCampeoes = true
        this.loadingLeais = true
        this.loadingHibernando = true
        this.loadingPreocupantes = true
        this.loadingRisco = true
        this.loadingNaoPerder = true
        this.loadingNovos = true
        this.loadingPromissores = true
        this.loadingPotencias = true

        this.showDelhamentoClientesCampeoes()
        this.showDadosClientesLeais()
        this.showDadosClientesHibernando()
        this.showDadosNovosClientes()
        this.showDadosClientesPreocupantes()
        this.showDadosMatrizRiscoRFV()
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async showDelhamentoClientesCampeoes () {
        await Cliente.showClienteCampeoes(this.primeiroDia, this.ultimoDia, this.select, this.vendedores, localStorage.tokencontrato, this.area, this.rede, this.supervisor, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.clientesCampeoes = resposta.data.clientesCampeoes.toString()
            this.dadosCampeoes = resposta.data.dadosCampeoes

            this.clientesPromissores = resposta.data.clientesPromissores.toString()
            this.dadosPromissores = resposta.data.dadosPromissores

            this.clientesPotencias = resposta.data.clientesPotenciais.toString()
            this.dadosPotencias = resposta.data.dadosPotenciais
          } else if (resposta.data.msg === 'Não há dados de clientes campeões no período selecionado') {
            this.clientesCampeoes = '0'
            this.dadosCampeoes = []

            this.clientesPromissores = '0'
            this.dadosPromissores = []

            this.clientesPotencias = '0'
            this.dadosPotencias = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.errorCampeoes = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loadingCampeoes = false

          this.loadingPromissores = false

          this.loadingPotencias = false
        })
      },

      async showDadosClientesLeais () {
        await Cliente.showClienteLeais(this.primeiroDia, this.ultimoDia, this.select, this.vendedores, localStorage.tokencontrato, this.area, this.rede, this.supervisor, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.clientesLeais = resposta.data.clientesLeais.toString()

            this.dadosLeais = resposta.data.dadosLeais
          } else if (resposta.data.msg === 'Não há dados de clientes leais no período selecionado') {
            this.clientesLeais = '0'
            this.dadosLeais = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.errorLeais = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingLeais = false })
      },

      async showDadosClientesHibernando () {
        await Cliente.showClienteHibernando(this.primeiroDia, this.ultimoDia, this.select, this.vendedores, localStorage.tokencontrato, this.area, this.rede, this.supervisor, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.clientesHibernando = resposta.data.clientesHibernando.toString()
            this.dadosHibernando = resposta.data.dadosHibernando

            this.clientesRisco = resposta.data.clienteRisco.toString()
            this.dadosRisco = resposta.data.dadosRisco
          } else if (resposta.data.msg === 'Não há dados de clientes leais no período selecionado') {
            this.clientesHibernando = '0'
            this.clientesRisco = '0'

            this.dadosHibernando = []
            this.dadosRisco = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.errorHibernando = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loadingHibernando = false

          this.loadingRisco = false
        })
      },

      async showDadosNovosClientes () {
        await Cliente.showNovosCliente(this.primeiroDia, this.ultimoDia, this.select, this.vendedores, localStorage.tokencontrato, this.area, this.rede, this.supervisor, this.receita, this.segmento, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.clientesNovos = resposta.data.novosClientes.toString()

            this.dadosNovos = resposta.data.dadosNovosClientes
          } else if (resposta.data.msg === 'Não há dados para o período selecionado') {
            this.clientesNovos = '0'

            this.dadosNovos = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.errorNovos = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingNovos = false })
      },

      async showDadosClientesPreocupantes () {
        await Cliente.showClientePreocupantes(this.primeiroDia, this.ultimoDia, this.select, this.vendedores, localStorage.tokencontrato, this.area, this.rede, this.supervisor, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.clientesPreocupantes = resposta.data.clientesPreocupantes.toString()
            this.clientesNaoPerder = resposta.data.clientesNaoPerder.toString()

            this.dadosPreocupantes = resposta.data.dadosPreocupantes
            this.dadosNaoPerder = resposta.data.dadosNaoPerder

            eventEmit.$emit('set-dados-geolocalizacao', this.dadosCampeoes, this.dadosPromissores, this.dadosPotencias, this.dadosLeais, this.dadosHibernando, this.dadosRisco, this.dadosNovos, this.dadosPreocupantes, this.dadosNaoPerder, this.primeiroDia, this.ultimoDia, this.vendedores, this.area, this.rede, this.supervisor, this.receita, this.segmento, this.select, this.categoria, this.promotor)
          } else if (resposta.data.msg === 'Não há dados de clintes para o período selecionado') {
            this.clientesPreocupantes = '0'
            this.clientesNaoPerder = '0'

            this.dadosPreocupantes = []
            this.dadosNaoPerder = []

            eventEmit.$emit('set-dados-geolocalizacao', this.dadosCampeoes, this.dadosPromissores, this.dadosPotencias, this.dadosLeais, this.dadosHibernando, this.dadosRisco, this.dadosNovos, this.dadosPreocupantes, this.dadosNaoPerder, this.primeiroDia, this.ultimoDia, this.vendedores, this.area, this.rede, this.supervisor, this.receita, this.segmento, this.select, this.categoria, this.promotor)

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.errorPreocupantes = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loadingPreocupantes = false

          this.loadingNaoPerder = false
        })
      },

      async showDadosMatrizRiscoRFV () {
        Cliente.showClientesMatrizRiscoRFV(this.primeiroDia, this.ultimoDia, this.select, this.vendedores, localStorage.tokencontrato, this.area, this.rede, this.supervisor, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.dadosMatriz = resposta.data.dadosMatriz
          } else if (resposta.data.msg === 'Não há dados para montar a matriz de risco no período selecionado') {
            this.dadosMatriz = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      getColorR1 (value) {
        if (value.frequencia === 'FV1 - Muito baixo' || value.frequencia === 'FV2 - Baixo' || value.frequencia === 'FV3 - Bom') {
          return '#d55f2b'
        } else {
          return '#f27059'
        }
      },

      getColorR2 (value) {
        if (value.frequencia === 'FV1 - Muito baixo' || value.frequencia === 'FV2 - Baixo' || value.frequencia === 'FV3 - Bom') {
          return '#f7b267'
        } else {
          return '#f6d2a8'
        }
      },

      getColorR3 (value) {
        if (value.frequencia === 'FV1 - Muito baixo' || value.frequencia === 'FV2 - Baixo') {
          return '#a7c8de'
        } else {
          return '#add7a1'
        }
      },

      getColorR4 (value) {
        if (value.frequencia === 'FV1 - Muito baixo' || value.frequencia === 'FV2 - Baixo') {
          return '#7aacd2'
        } else {
          return '#add7a1'
        }
      },

      getColorR5 (value) {
        if (value.frequencia === 'FV1 - Muito baixo') {
          return '#4780b8'
        } else if (value.frequencia === 'FV2 - Baixo') {
          return '#7aacd2'
        } else {
          return '#55a15c'
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style lang="sass">
  #iconInformationClientesNovos
    margin: 0 0 0 -1rem

  #iconInformationClientesPromissores
    margin: 0 0 0 -1rem

  #iconInformationClientesPotencias
    margin: 0 0 0 -1rem

  #valorClientes
    font-size: 18px
    font-weight: bold

  #valorClientesCampeoes
    margin: 3rem 0 3rem 0

  #clientesHibernando
    margin-top: -2.3rem

  #clientesPotencias
    margin-top: -2.3rem

  #valorClientesBloco3
    margin: 2rem 0 2rem 0

  #listItemTextoRelatorio
    padding-right: 116rem !important
    margin: -2rem 0 0 -1rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #componenteClientes
    margin: -1rem 0 0 0

  #componenteClientesLeais
    margin: -3rem 0 0 0

  #listItemDistribuicaoClientes
    padding-right: 63rem !important
    margin: -2rem 0 0 -1rem

  #listItemMatrizRisco
    padding-right: 113rem !important
    margin: -2rem 0 0 -1rem

</style>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersMelhoresClientes {
      width: 100% !important;
    }

    #listItemMatrizRisco {
      padding-right: 9rem !important
    }

    #listItemDistribuicaoClientes {
      padding-right: 9rem !important
    }

    #listItemTextoRelatorio {
      padding-right: 9rem !important
    }

    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px !important;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen
  and (min-width : 1200px)
  and (max-width : 1600px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }
</style>
